const defaultOptions = {
  type: 'up',
  delay: 0,
  threshold: 0.12,
}

function parseBinding(value) {
  if (!value) return { ...defaultOptions }
  if (typeof value === 'string') return { ...defaultOptions, type: value }
  return { ...defaultOptions, ...value }
}

function applyVisible(el, { delay }) {
  if (delay > 0) {
    el.style.transitionDelay = `${delay}ms`
  }
  el.classList.add('scroll-reveal--visible')
}

export default {
  inserted(el, binding) {
    const options = parseBinding(binding.value)
    el.classList.add('scroll-reveal')
    el.classList.add(`scroll-reveal--${options.type}`)

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            applyVisible(el, options)
            observer.unobserve(el)
          }
        })
      },
      {
        threshold: options.threshold,
        rootMargin: '0px 0px -40px 0px',
      }
    )

    observer.observe(el)
    el._scrollRevealObserver = observer
  },
  unbind(el) {
    if (el._scrollRevealObserver) {
      el._scrollRevealObserver.disconnect()
      delete el._scrollRevealObserver
    }
  },
}
